export default {
  routings: state => state.routings,
  users: state => state.users,
  requestStatus: state => state.requestStatus,
  activeRouting: state => state.activeRouting,
  activeUser: state => state.activeUser,
  breadcrumbs: state => state.breadcrumbs,
};
